import React from 'react';

/**
 * Pill-style topic bar for the active help section, wrapped in a
 * horizontally-scrollable container (Policy 3), plus the scrollable HTML
 * content pane for the selected topic. `body` is trusted, hand-authored HTML
 * from helpContent.js — never bound to user input.
 */
export default function HelpContent({ section, activeTopicId, onSelectTopic }) {
  if (!section) {
    return (
      <div className="help-drawer-content p-3">
        <p className="text-muted mb-0">No help topics yet for this section.</p>
      </div>
    );
  }

  const activeTopic = section.topics.find((t) => t.id === activeTopicId) || section.topics[0] || null;

  return (
    <div className="help-drawer-content">
      <div className="help-drawer-topic-pills px-3 pt-3">
        {section.topics.length === 0 ? (
          <span className="text-muted small">No topics yet in this section.</span>
        ) : (
          section.topics.map((topic) => (
            <button
              key={topic.id}
              type="button"
              className={`btn btn-sm rounded-pill help-drawer-pill${topic.id === activeTopic?.id ? ' active' : ''}`}
              onClick={() => onSelectTopic(topic.id)}
            >
              {topic.title}
            </button>
          ))
        )}
      </div>

      <div className="help-drawer-topic-body p-3">
        {activeTopic ? (
          <div dangerouslySetInnerHTML={{ __html: activeTopic.body }} />
        ) : (
          <p className="text-muted mb-0">Select a topic above to read more.</p>
        )}
      </div>
    </div>
  );
}
